import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Button, Checkbox, CircularProgress, Grid, Pagination, TextField, Typography } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom';
import { getClientes, getEstados, getOpcionesTareas, getTareas, getTareaSA, getTrabajadores } from '../../../../services/apis';
import SquareIcon from '@mui/icons-material/Square';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SearchIcon from '@mui/icons-material/Search';

import { ErrorYRedireccionar } from '../../../../utils/componentes-utiles/ErrorYRedireccionar';
import { FormCrearSA } from '../FormCrearSA';
import { FormCrearTarea } from '../FormCrearTarea';
import { TareaCard } from '../TareaCard';
import { TareaSaCard } from './TareaSaCard';
import AutocompleteList from '../../../../utils/componentes-utiles/AutocompleteList';
import debounce from 'lodash.debounce';
import { SubHeader } from '../../../../utils/componentes-utiles/SubHeader';
import { Error } from '../../../../utils/componentes-utiles/Error';
import { useInterval } from 'react-use';
import { filtrarProyectosVisibles, ordenarOpcionesPorLabel, textoMayusculas } from '../../../../utils/utils';

export const TareasSolicitudes = () => {
    const iconMapping = {
        AddCircleIcon: <AddCircleIcon />

    };
    const Navigate = useNavigate();
    const [contadorError, setContadorError] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const [tareas, setTareas] = useState([]);
    const [opciones, setOpciones] = useState([]);
    const [estados, setEstados] = useState([]);
    const estadosRef = useRef(estados);
    const [crearTarea, setCrearTarea] = useState(false);
    const [crearSA, setCrearSA] = useState(false);
    const [opcionesTareas, setOpcionesTareas] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [opclientes, setOpClientes] = useState([]);
    const [opTrabajadores, setOpTrabajadores] = useState([]);
    const [nombreProyecto, setNombreProyecto] = useState([]);
    const [tareasFiltradas, setTareasFiltradas] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [trabajadorSelec, setTrabajadorSelec] = useState({ label: "Aginar a un Trabajador", value: "0" });
    const [clientesSelec, setClientesSelec] = useState({ label: "Aginar a un Trabajador", value: "0" });
    const [proyectoSelec, setProyectoSelec] = useState([{ label: 'Solicitudes Ayuda', value: 0 }]);
    const [totalTareas, setTotalTareas] = useState(0);
    const [cargaFiltrados, setcargaFiltrados] = useState(false);
    const [opProyectos, setOpProyectos] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 100; // Máximo de artículos por página

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
        handleScrollToTop();
    };
    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // Desplazamiento suave
        });
    }

    const param = useParams();
    const paramRef = useRef(param);

    // Obtener la fecha actual y la fecha de hace 2 meses
    const today = new Date();
    const twoMonthsAgo = new Date();
    twoMonthsAgo.setMonth(today.getMonth() - 6);

    // Formatear las fechas en formato 'YYYY-MM-DD' (ISO)
    const formatDate = (date) => {
        return date.toISOString().split('T')[0];
    };

    const [filtros, setFiltros] = useState(
        {
            fechaDesde: formatDate(twoMonthsAgo),  // Fecha de hace 2 meses
            fechaHasta: formatDate(today),         // Fecha actual

        }
    );
    const filtrosRef = useRef(filtros);

    const handleSearch = (event) => {
        setSearchTerm(event.target.value.toLowerCase());
        setCurrentPage(1);

    };


    const debouncedHandleSearch = useCallback(debounce(handleSearch, 1000), []);


    // useEffect(() => {
    //     const tempFIl = filtrarTareas(estados, tareas);
    //     setTareasFiltradas(tempFIl);
    // }, [tareas]);

    // También puedes cargar otras funciones fuera del intervalo
    useEffect(() => {
        // primeraCarga();
        cargarOpcionesTareas();
        cargarClientes();
        cargarTrabajadores();
        cargarEstados();
    }, []);
    // useEffect(() => {
    //     filtrosRef.current = filtros;
    //     console.log(estados);

    //     cargarTareas();
    // }, [filtros, estados]);



    // useEffect(() => {
    //     setTareasFiltradas(filtrarTareas(estados, tareas));
    // }, [trabajadorSelec, searchTerm])

    // useEffect(() => {
    //     estadosRef.current = estados;
    // }, [estados]);

    useEffect(() => {
        setcargaFiltrados(false);
        filtrosRef.current = filtros;
        cargarTareas();
    }, [filtros, estados, currentPage, trabajadorSelec, clientesSelec, proyectoSelec, searchTerm]);

    useEffect(() => {
        paramRef.current = param;
    }, [param]);
    const handleChange = (event) => {

        const tareaNueva = { ...filtros, [event.target.name]: event.target.value };

        setFiltros(tareaNueva);
        if (event.target.name == ('fechaDesde' || 'fechaHasta')) {
            cargarEstados();
        }

    }
    const primeraCarga = async () => {
        let fechaDesde = filtros.fechaDesde;
        let fechaHasta = filtros.fechaHasta;

        try {
            const response = await getTareaSA(param.id, 1, fechaDesde, fechaHasta);
            setTareas(response.data.tareas);
            setTareasFiltradas(response.data.tareas);
            setOpciones(response.data.opcionesTareas);
            setNombreProyecto(response.data.nombreProyecto[0].nombre)
            setLoaded(true);
            setContadorError(0)
            document.title = `(${tareasFiltradas.length}) Tessa: ${response.data.nombreProyecto[0].nombre} Tareas`;

        } catch (error) {
            setContadorError(contadorError + 1);
            if (contadorError > 3) {
                console.error("Error cargar tareas:", error);
                localStorage.clear();
                Navigate("/login");
                document.cookie = "PHPSESSID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            }
        }

    }
    const cargarTareas = async () => {
        let fechaDesde = filtrosRef.current.fechaDesde;
        let fechaHasta = filtrosRef.current.fechaHasta;

        const estadosFiltroStr = estados
            .filter(estado => estado.checked === 1 || estado.checked === true)
            .map(estado => estado.id)
            .join(',');
        console.log("Estados Filtro:", estadosFiltroStr, estados);
        const empleadosFiltro = Array.isArray(trabajadorSelec)
            ? trabajadorSelec.map(e => e.value).join(',')
            : trabajadorSelec?.value || '';

        const clientesFiltro = Array.isArray(clientesSelec)
            ? clientesSelec.map(c => c.value).join(',')
            : clientesSelec?.value || '';

        const proyectosFiltro = Array.isArray(proyectoSelec)
            ? proyectoSelec.map(p => p.value).join(',')
            : proyectoSelec?.value || '';
        try {
            const response = await getTareaSA(param.id,
                1,
                fechaDesde,
                fechaHasta,
                estadosFiltroStr,
                itemsPerPage,
                currentPage,
                proyectosFiltro,
                empleadosFiltro,
                clientesFiltro,
                searchTerm
            );

            setTareas(response.data.tareas);
            iterarProyectos(response.data.nombreProyecto);
            setTotalTareas(response.data.total);
            setContadorError(0);
            setcargaFiltrados(true);
            setLoaded(true);
            setOpciones(response.data.opcionesTareas);

            document.title = `(${response.data.total}) Tessa: ${response.data.nombreProyecto[0].nombre} Tareas`;

        } catch (error) {
            setContadorError(contadorError + 1);
            if (contadorError > 3) {
                console.error("Error cargar tareas:", error);
                localStorage.clear();
                Navigate("/login");
                document.cookie = "PHPSESSID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            }

        }

    }
    useInterval(cargarTareas, 30000);

    const cargarOpcionesTareas = async () => {
        try {
            const response = await getOpcionesTareas(param.id);
            setOpcionesTareas(response.data);
        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }


    const cargarEstados = async () => {
        try {
            const response = await getEstados();
            const conChecked = response.data.estados.map(e => ({ ...e, checked: e.checked == 1 ? 1 : 0 }));
            setEstados(conChecked);
            // Actualizamos el ref inmediatamente
            estadosRef.current = conChecked;
        } catch (error) {
            console.error("Error al añadir el cliente:", error);
        }

    }
    const cargarClientes = async () => {
        try {
            const response = await getClientes();
            setClientes(response.data);
            const tmp = [...response.data];
            const newTmp = ordenarOpcionesPorLabel(tmp.map((item, index) => ({
                label: textoMayusculas(item.nombre),
                value: item.id
            })))
            setOpClientes(newTmp);
        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }
    const cargarTrabajadores = async () => {
        try {
            const response = await getTrabajadores();
            const tmp = [...response.data];
            const newTmp = ordenarOpcionesPorLabel(tmp.map((item, index) => ({
                label: textoMayusculas(item.nombre),
                value: item.id
            })))
            setOpTrabajadores(newTmp);
        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }

    const iterarProyectos = (data) => {
        try {
            const tmp = filtrarProyectosVisibles(data);
            const newTmp = ordenarOpcionesPorLabel([
                // Proyecto por defecto
                ...tmp.map((item) => ({
                    label: textoMayusculas(item.nombre),
                    value: item.id,
                    oculto: item.oculto
                }))
            ]);
            setOpProyectos(newTmp);
            console.log("Proyectos:", newTmp);

            // setProyectoSelec([{ label: 'Solicitudes Ayuda', value: 0 }]);
        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }
    const handleEvent = (opcionId) => {
        switch (opcionId) {
            case 1:
                setCrearTarea(true);

                // Lógica para la opción 1
                break;
            case 2:
                setCrearSA(true);
                break;
            default:
                console.log("Lógica para una opción desconocida");
                // Lógica para una opción desconocida
                break;
        }
    }
    const handleCheckboxChange = (id) => {
        let temp = [...estados]
        const updatedEstados = temp.map((estado) =>
            estado.id === id ? { ...estado, checked: !estado.checked } : estado
        );

        setEstados(updatedEstados);
        setTareasFiltradas(filtrarTareas(updatedEstados, tareas));
    };
    //filtros Estados
    const filtrarTareas = (updatedEstados, tareas) => {
        // Filtrar por estados >>>>

        // Obtén los IDs de los estados marcados
        const checkedEstadoIds = updatedEstados
            .filter(estado => estado.checked)
            .map(estado => estado.id);

        // Filtra las tareas según los estados marcados
        const filteredTareas = tareas.filter(tarea =>
            checkedEstadoIds.includes(tarea.id_estado)
        );

        let tareasFiltradasPorTrabajadores = filteredTareas;
        // Filtrar las tareas por trabajadores seleccionados
        if (trabajadorSelec.length > 0) {
            tareasFiltradasPorTrabajadores = filteredTareas.filter(tarea =>
                Array.isArray(tarea.trabajadores) && tarea.trabajadores.some(trabajador =>
                    Array.isArray(trabajadorSelec) && trabajadorSelec.some(selTrab => selTrab.value === trabajador.value)
                )
            );
        }
        let tareasFiltradasPorClientes = tareasFiltradasPorTrabajadores;




        //filtrar por texto
        if (searchTerm.length > 1) {
            const propiedadesParaBuscar = ['asunto', 'descripcion', 'fecha', 'cliente', 'correo', 'trabajadores', 'id'];

            tareasFiltradasPorClientes = tareasFiltradasPorClientes.filter(tarea =>
                propiedadesParaBuscar.some(propiedad => {
                    const valorProp = tarea[propiedad];
                    // Si es null o undefined, lo saltamos
                    if (valorProp == null) return false;
                    // Convertimos todo a string y bajamos a minúsculas
                    const texto = String(valorProp).toLowerCase();
                    return texto.includes(searchTerm.toLowerCase());
                })
            );

        }


        document.title = `(${tareasFiltradasPorClientes.length}) Tessa: Tareas`; // Actualiza el título del documento
        return tareasFiltradasPorClientes; // Devuelve las tareas filtradas
    };

const currentTareas = tareas;

    return (
        <div className='fade-in-2 '><SubHeader />
            {!loaded && (
                <CircularProgress size={40} />
            )}
            {(loaded && estados.length > 0) && (
                <>

                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        xs={12}
                        gap={1}
                    >
                        <Grid item xs={12}>
                            <Typography variant='h4' gutterBottom>
                                {nombreProyecto} {totalTareas} TAREAS
                            </Typography>
                        </Grid>

                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            xs={12}
                        >
                            {opcionesTareas.map((opcion, index) => (
                                <Grid item xs={4} sm={3} md={3} lg={2} xl={1}>
                                    <Button
                                        fullWidth
                                        size='small'
                                        variant='contained'
                                        key={index}
                                        onClick={() => handleEvent(opcion.id)}
                                        disabled={false}
                                        startIcon={iconMapping[opcion.icon]}
                                    >
                                        {opcion.nombre}
                                    </Button>
                                </Grid>
                            ))}
                        </Grid>

                    </Grid>
                    <div className="flex-center">
                        {loaded && (

                            <Grid container gap={2} maxWidth={"90%"} direction="row" justifyContent="center" alignItems="center"  >

                                {estados.length > 0 && (
                                    <>
                                        {/* filtros */}
                                        <Grid
                                            container
                                            direction="column"
                                            justifyContent="center"
                                            alignItems="center"
                                            xs={12}
                                        >
                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="center"
                                                alignItems="center"
                                                xs={12}
                                                sx={{ mt: 2 }}
                                            >
                                                <Pagination
                                                    count={Math.ceil(totalTareas / itemsPerPage)}
                                                    page={currentPage}
                                                    siblingCount={0}
                                                    onChange={handlePageChange}
                                                    color="primary"
                                                />
                                            </Grid>

                                            <Grid
                                                container
                                                direction="row"
                                                justifyContent="space-around"
                                                alignItems="end"
                                                xs={12}
                                                gap={1}
                                                sx={{ mt: 1 }}
                                            >
                                                <Grid item xs={5} sm={2.5} md={1.5} lg={1.5} xl={1.5}>
                                                    <TextField
                                                        fullWidth
                                                        type="date"
                                                        id="dateInput"
                                                        label="Fecha Desde"
                                                        name="fechaDesde"
                                                        // className={filtros.fechaDesde ? "inputDateInput" : 'inputDateInput-empty'}
                                                        value={filtros.fechaDesde ? filtros.fechaDesde : new Date().toISOString().split('T')[0]} // Se establece la fecha de hoy si compra.Fecha es null
                                                        onChange={handleChange}
                                                    />
                                                </Grid>

                                                <Grid item xs={5} sm={2.5} md={1.5} lg={1.5} xl={1.5}>
                                                    <TextField
                                                        fullWidth
                                                        type="date"
                                                        id="dateInput"
                                                        name="fechaHasta"
                                                        label="Fecha Hasta"
                                                        className={filtros.fechaHasta ? "inputDateInput" : 'inputDateInput-empty'}
                                                        value={filtros.fechaHasta ? filtros.fechaHasta : new Date().toISOString().split('T')[0]} // Se establece la fecha de hoy si compra.Fecha es null
                                                        onChange={handleChange}
                                                    />
                                                </Grid>

                                                <Grid item xs={11} sm={5} md={4.5} lg={2} xl={2}>
                                                    <AutocompleteList array={opTrabajadores} setArray={setTrabajadorSelec} label={"Asignados"}></AutocompleteList>
                                                </Grid>

                                                <Grid item xs={11} sm={12} md={12} lg={3} xl={3}>
                                                    <TextField
                                                        // className="textfieldBuscador"
                                                        onChange={debouncedHandleSearch}
                                                        label="Buscar"
                                                        fullWidth
                                                    />
                                                </Grid>

                                            </Grid>
                                        </Grid>


                                        {/* // leyentda estadoas */}

                                        <Grid container xs={12} direction="row" justifyContent="center" alignItems="center" fontWeight={700} >
                                            {estados.map(estado => (
                                                <Grid container xs={6} sm={4} md={3} xl={2} direction="row" justifyContent="center" alignItems="center" fontWeight={700} key={estado.id}>
                                                    {estado.nombre}&nbsp; <SquareIcon style={{
                                                        color: "#" + estado.color,
                                                        backgroundColor: "#" + estado.color,
                                                        borderRadius: "4px",
                                                        boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px'
                                                    }} />
                                                    <Checkbox
                                                        checked={estado.checked}
                                                        onChange={() => handleCheckboxChange(estado.id)}  // Cambia el estado al hacer clic
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                    />
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </>
                                )}
                                <h1>{tareas.length > 0 ? '' : <Error mensaje={'No hay Tareas todavía'} />}</h1>

                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="start"
                                    xs={12}
                                    gap={2}
                                    sx={{ mt: -5 }}
                                >
                                    {currentTareas.map((tarea, index) => (
                                        <Grid container xs={12} sm={6} md={4} xl={2} direction="row" justifyContent="center" alignItems="center" fontWeight={700} key={tarea.id} >
                                            <TareaSaCard tarea={tarea} opciones={opciones} estados={estados} cargarTareas={cargarTareas} opclientes={opclientes} opTrabajadores={opTrabajadores} />
                                        </Grid>
                                    ))}
                                </Grid>

                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    marginBottom={"3em"}
                                    xs={12}
                                    sx={{ mt: 5 }}
                                >
                                    <Pagination
                                        count={Math.ceil(totalTareas / itemsPerPage)}
                                        page={currentPage}
                                        siblingCount={0}
                                        onChange={handlePageChange}
                                        color="primary"
                                    />
                                </Grid>

                            </Grid>
                        )}
                        <FormCrearTarea open={crearTarea} setOpen={setCrearTarea} opclientes={opclientes} opTrabajadores={opTrabajadores} cargarTareas={cargarTareas} />
                        <FormCrearSA open={crearSA} setOpen={setCrearSA} opclientes={opclientes} opTrabajadores={opTrabajadores} cargarTareas={cargarTareas} />

                    </div>
                </>
            )}

        </div>
    )
}
